<header class="header-area p-relative">
        <!-- <div class="top-header top-header-style-four">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <ul class="top-header-contact-info">
                        <li>
                            Call: 
                            <a href="tel:+502464674">+502 464 674</a>
                        </li>
                    </ul>
                    <div class="top-header-social">
                        <span>Follow us:</span>
                        <a href="#" target="_blank"><i class='bx bxl-facebook'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-twitter'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-instagram'></i></a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4">
                    <ul class="top-header-login-register">
                        <li><a routerLink="/login"><i class='bx bx-log-in'></i> Login</a></li>
                        <li><a routerLink="/register"><i class='bx bx-log-in-circle'></i> Register</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div> -->
        <div class="navbar-area navbar-style-three" [ngClass]="{'sticky': isSticky}">
                <div class="container">
                        <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
                                <a class="navbar-brand" routerLink="/" style="width: 12%;"><img class="w-100"
                                                src="assets/story/logo/story-line.png" alt="logo"></a>
                                <button class="navbar-toggler" type="button" (click)="toggleClass()">
                                        <span class="burger-menu">
                                                <span class="top-bar"></span>
                                                <span class="middle-bar"></span>
                                                <span class="bottom-bar"></span>
                                        </span>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                        <ul class="navbar-nav">
                                                <li *ngFor="let item of menu" class="nav-item">
                                                        <a routerLink="{{ item.route }}" class="nav-link"
                                                                routerLinkActive="active"
                                                                [routerLinkActiveOptions]="{exact: true}">{{ item.title
                                                                }}</a>
                                                </li>
                                        </ul>

                                </div>
                                <!-- <div class="others-option">
                                        <div class="dropdown language-switcher d-inline-block"
                                                [class.active]="classApplied2">
                                                <button class="dropdown-toggle" type="button" (click)="toggleClass2()">
                                                        <img src="assets/img/us-flag.jpg" class="shadow" alt="image">
                                                        <span>Eng <i class='bx bx-chevron-down'></i></span>
                                                </button>
                                                <div class="dropdown-menu">
                                                        <a href="#" class="dropdown-item d-flex align-items-center">
                                                                <img src="assets/img/germany-flag.jpg" class="shadow-sm"
                                                                        alt="flag">
                                                                <span>Ger</span>
                                                        </a>
                                                        <a href="#" class="dropdown-item d-flex align-items-center">
                                                                <img src="assets/img/france-flag.jpg" class="shadow-sm"
                                                                        alt="flag">
                                                                <span>Fre</span>
                                                        </a>
                                                        <a href="#" class="dropdown-item d-flex align-items-center">
                                                                <img src="assets/img/spain-flag.jpg" class="shadow-sm"
                                                                        alt="flag">
                                                                <span>Spa</span>
                                                        </a>
                                                        <a href="#" class="dropdown-item d-flex align-items-center">
                                                                <img src="assets/img/russia-flag.jpg" class="shadow-sm"
                                                                        alt="flag">
                                                                <span>Rus</span>
                                                        </a>
                                                        <a href="#" class="dropdown-item d-flex align-items-center">
                                                                <img src="assets/img/italy-flag.jpg" class="shadow-sm"
                                                                        alt="flag">
                                                                <span>Ita</span>
                                                        </a>
                                                </div>
                                        </div>
                                </div> -->
                        </nav>
                </div>
        </div>
</header>

<!-- <div class="search-overlay" [class.active]="classApplied3">
        <div class="d-table">
                <div class="d-table-cell">
                        <div class="search-overlay-layer"></div>
                        <div class="search-overlay-layer"></div>
                        <div class="search-overlay-layer"></div>
                        <div class="search-overlay-close" (click)="toggleClass3()">
                                <span class="search-overlay-close-line"></span>
                                <span class="search-overlay-close-line"></span>
                        </div>
                        <div class="search-overlay-form">
                                <form>
                                        <input type="text" class="input-search" placeholder="Search here...">
                                        <button type="submit"><i class='bx bx-search-alt'></i></button>
                                </form>
                        </div>
                </div>
        </div>
</div> -->